import { ApiCreateEmailResponse, PrayCreateEmailResponse } from '../types';

export const mapCreateEmailResponse = (response: ApiCreateEmailResponse): PrayCreateEmailResponse => {
  return {
    emailUsername: response.email_username,
    domain: {
      dnsRecords: {
        mailCname: {
          valid: response.domain.dns_records.mail_cname.valid,
          type: response.domain.dns_records.mail_cname.type,
          host: response.domain.dns_records.mail_cname.host,
          data: response.domain.dns_records.mail_cname.data,
        },
        dkim1: {
          valid: response.domain.dns_records.dkim1.valid,
          type: response.domain.dns_records.dkim1.type,
          host: response.domain.dns_records.dkim1.host,
          data: response.domain.dns_records.dkim1.data,
        },
        dkim2: {
          valid: response.domain.dns_records.dkim2.valid,
          type: response.domain.dns_records.dkim2.type,
          host: response.domain.dns_records.dkim2.host,
          data: response.domain.dns_records.dkim2.data,
        },
        dmarc: response.domain.dns_records.dmarc
          ? {
              valid: response.domain.dns_records.dmarc.valid,
              type: response.domain.dns_records.dmarc.type,
              host: response.domain.dns_records.dmarc.host,
              data: response.domain.dns_records.dmarc.data,
            }
          : null,
      },
      id: response.domain.id,
      deletedAt: response.domain.deleted_at,
      internalId: response.domain._id,
      artistId: response.domain.artist_id,
      domainName: response.domain.domain_name,
      status: response.domain.status,
      isPrimary: response.domain.is_primary,
      sendgridDomainId: response.domain.sendgrid_domain_id,
      updatedAt: response.domain.updated_at,
      createdAt: response.domain.created_at,
    },
  };
};
